import React from 'react'
import PropTypes from 'prop-types'

import LogInContext from '../../../context/LogInContext'

function RedeemMailOfferButton({ href, className, dataEvent, children }) {
  return (
    <LogInContext.Consumer>
      <a className={className} href={href} data-event={dataEvent}>
        {children}
      </a>
    </LogInContext.Consumer>
  )
}

RedeemMailOfferButton.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  dataEvent: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
}

export default RedeemMailOfferButton
